import { call, put, takeLatest } from 'redux-saga/effects'
import axiosApi from '../../views/client/axiosClient'
import { handleRequest } from '../../lib/common'
import {Constants, setData, setLoading } from './actions'

function* getData(formData) {
  try {
    const request = axiosApi().post(
      Constants.GET_DATA_API,
      formData.payload
    )
    yield put(setLoading(true))
    
    const response = yield call(handleRequest, request)
    if (!response.data) {
      return
    }
    const data = JSON.parse(response.data)
    if (data.dataChart) {
      yield put(setData(data.dataChart))
    }
  } catch (error) {
    console.log(error)
  } finally {
    yield put(setLoading(false))
  }
}

function* chartWatcher() {
  yield [
    takeLatest(Constants.GET_DATA, getData)
  ]
}

export default chartWatcher


// WEBPACK FOOTER //
// ./src/components/Chart/sagas.js